import React from 'react';
import clx from 'classnames';
import './IconVector.scss';
import {
  iconVectorBoolean,
  iconVectorCalculate,
  iconVectorCurrency,
  iconVectorDate,
  iconVectorDateRange,
  iconVectorDinamicText,
  iconVectorEmail,
  iconVectorFreeText,
  iconVectorinfoNote,
  iconVectorList,
  iconVectorMetadata,
  iconVectorMultipleChoice,
  iconVectorNumeric,
  iconVectorRegion,
  iconVectorSectionTitle,
  iconVectorSingleChoice,
  iconVectorSpace,
  iconVectorTextual,
  iconVectorUpload,
  iconVectorCitizen,
  iconVectorCompany,
  iconVectorNote,
  iconVectorSubTitle,
  iconVectorTitle,
  iconVectorJustify,
  iconVectorCenter,
  iconVectorLeft,
  iconVectorRight,
  iconVectorContextData,
  iconVectorMetadataData,
  iconVectorCaptcha,
  iconVectorUploadSigned,
  iconVectorPreview,
  iconVectorCascadeSelect,
  iconGraphicDivider,
  iconVectorMultiPreference,
  iconVectorComputed
} from './iconsSvg';
import { WidgetInputType } from 'common/schema/widget/input/WidgetInputType';
import { WidgetDynamicType } from 'common/schema/widget/dynamic/WidgetDynamic';
import { WidgetGraphicType } from 'common/schema/widget/graphic/WidgetGraphic';
import {
  PrintItemTextBlock,
  PrintItemType
} from 'common/schema/print-item/PrintItem';

export type IIconVectorType =
  | 'InputBoolean'
  | 'InputCalculate'
  | 'DynamicField'
  | 'InputCurrency'
  | 'InputDate'
  | 'InputDateInterval'
  | 'PdfDinamicText'
  | 'InputEmail'
  | 'GraphicText'
  | 'GraphicNote'
  | 'GraphicInfo'
  | 'InputList'
  | 'PdfMetadata'
  | 'InputMultipleChoice'
  | 'InputNumeric'
  | 'InputRegion'
  | 'GraphicSection'
  | 'InputSingleChoice'
  | 'PdfSpace'
  | 'InputText'
  | 'InputFile'
  | 'Citizen'
  | 'Company'
  | 'Employee'
  | 'Note'
  | 'Title'
  | 'SubTitle'
  | 'ContextualValue'
  | 'MetadataData'
  | 'InputCaptcha'
  | 'InputSignedFile'
  | 'InputUploadSigned'
  | 'InputPreview'
  | 'InputCascadeSelect'
  | 'InputMultiPreference';

/**
 * Ritorna l'immagine .svg di un icona
 */
const icon = (vector: string) => {
  switch (vector) {
    case 'InputBoolean':
      return iconVectorBoolean;
    case 'InputCalculate':
    case 'DynamicField':
      return iconVectorCalculate;
    case 'DynamicComputedField':
      return iconVectorComputed;
    case 'InputCurrency':
      return iconVectorCurrency;
    case 'InputDate':
      return iconVectorDate;
    case 'InputDateInterval':
      return iconVectorDateRange;
    case 'PdfDinamicText':
    case 'PrintText':
      return iconVectorDinamicText;
    case 'InputEmail':
      return iconVectorEmail;
    case 'GraphicText':
      return iconVectorFreeText;
    case 'GraphicNote':
    case 'GraphicInfo':
      return iconVectorinfoNote;
    case 'InputList':
      return iconVectorList;
    case 'PdfMetadata':
    case 'PrintMetadata':
      return iconVectorMetadata;
    case 'InputMultipleChoice':
      return iconVectorMultipleChoice;
    case 'InputNumeric':
      return iconVectorNumeric;
    case 'InputRegion':
      return iconVectorRegion;
    case 'GraphicSection':
      return iconVectorSectionTitle;
    case 'InputSingleChoice':
      return iconVectorSingleChoice;
    case 'InputMultiPreference':
      return iconVectorMultiPreference;
    case 'InputCascadeSelect':
      return iconVectorCascadeSelect;
    case 'PdfSpace':
    case 'PrintSpace':
      return iconVectorSpace;
    case 'InputText':
      return iconVectorTextual;
    case 'InputFile':
      return iconVectorUpload;
    case 'Citizen':
      return iconVectorCitizen;
    case 'Employee':
      return iconVectorCitizen;
    case 'Company':
      return iconVectorCompany;
    case 'title':
      return iconVectorTitle;
    case 'subtitle':
      return iconVectorSubTitle;
    case 'note':
      return iconVectorNote;
    case 'justify':
      return iconVectorJustify;
    case 'center':
      return iconVectorCenter;
    case 'left':
      return iconVectorLeft;
    case 'right':
    case 'numbered':
    case 'bulleted':
      return iconVectorRight;
    case 'ContextualValue':
      return iconVectorContextData;
    case 'MetadataData':
      return iconVectorMetadataData;
    case 'InputCaptcha':
      return iconVectorCaptcha;
    case 'InputPreview':
      return iconVectorPreview;
    case 'GraphicDivider':
      return iconGraphicDivider;
    case 'InputSignedFile':
    case 'InputUploadSigned':
      return iconVectorUploadSigned;
  }
};

export interface IconVectorProps {
  size?: number;
  style?: React.CSSProperties;
  icon?:
    | IIconVectorType
    | WidgetInputType
    | WidgetGraphicType
    | WidgetDynamicType
    | PrintItemType
    | PrintItemTextBlock;
}

/**
 * Ritorna un icona Svg Stilizzata
 */
export function IconVector(props: IconVectorProps) {
  if (!props.icon) return null;

  const size = props.size ? props.size + 'px' : '1em';
  const style = props.style ?? {};
  style.width = size;
  style.height = size;

  return (
    <span
      className={clx('icon-vector', props.icon!.toLowerCase())}
      style={style}
    >
      {icon(props.icon)}
    </span>
  );
}
